import { css, styled } from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { ItemContainer, QueryBarWebsiteItem } from "@similarweb/ui-components";

import { DragHandleStyled } from "app/components/compare/WebsiteQueryBar/WebsiteQueryBar";

export const getDragBox = (isDragging: boolean) => styled.div`
    position: relative;
    border-radius: 8px;
    min-width: 0;
    margin-right: 24px;

    ${isDragging &&
    css`
        ${ItemContainer} {
            box-shadow: 0px 3px 5px 0px ${rgba(colorsPalettes.carbon[400], 0.12)};
            background-color: ${colorsPalettes.bluegrey[200]};
        }
    `}
    &:hover {
        ${DragHandleStyled} {
            opacity: 1;
        }
    }
`;

export const BrandChipItem = styled(QueryBarWebsiteItem)`
    height: 37px;
    width: unset;
    min-width: unset;
`;
